import type { TOptions, TPlayer } from 'video.js'

import './plugin'

// re-export plugin options and plugin class (as a type)
export type { MasterManifestData, TransmittedBytesData } from './plugin/index.h'
export type { StreamStatsPlugin } from './plugin'

/**
 * Configure stream stats addon before player initialization.
 */
export function configure(options: TOptions): TOptions {
  return options
}

/**
 * Injects stream stats addon into the player.
 * Collects stream manifest and traffic data from XHR and emits custom events.
 */
export function inject(player: TPlayer): TPlayer {
  player.streamStats()
  return player
}
